import React, { useEffect } from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react"
const LogoutForSignup = (props) => {
  const { logout } = useAuth0();

  useEffect(() => {
    logout({
      returnTo: window.location.origin + "/signup"
    })
  }, []);

  return (
    <></>
  );
}

export default withAuthenticationRequired(LogoutForSignup);